import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../contexts/AppContext';
import tenantApi from '../../utils/api/tenant';
import { toast } from 'react-toastify';
import ToggleSmall from '../Shared/Toggle/ToggleSmall';

const PDFEditting = () => {
  const [collapse, setCollapse] = useState(true);
  const [appendOnlyEnabled, setEnableAppendOnly] = useState<boolean>(false);
  const [lockAcrossAllProjects, setLockAcrossAllProjects] =
    useState<boolean>(false);
  const [busy, setBusy] = useState<boolean>(false);
  const appStore = useContext(AppContext);
  const user = appStore.get('user');

  const loadInitialData = () => {
    setBusy(true);
    tenantApi.pdfEditting
      .getAppendOnlyEnabled(user.tenantId)
      .then((res) => {
        if (res) {
          setEnableAppendOnly(res.append_only_enabled || false);
          setLockAcrossAllProjects(res.lock_append_only || false);
        }
        setBusy(false);
      })
      .catch((e) => {
        console.error('Error loading PDF Editting:', e);
        toast.error('Failed to load PDF Editting settings');
        setBusy(false);
      });
  };

  useEffect(() => {
    if (user && user.tenantId) {
      loadInitialData();
    }
  }, [user?.tenantId]);

  const handleAppendOnlyToggle = async () => {
    setBusy(true);

    try {
      await tenantApi.pdfEditting.editAppendOnlyEnabled(user.tenantId, {
        append_only_enabled: !appendOnlyEnabled,
      });

      setEnableAppendOnly(!appendOnlyEnabled);
      toast.success(
        `Append Only ${
          !appendOnlyEnabled ? 'enabled' : 'disabled'
        } successfully!`,
      );
    } catch (error) {
      console.error('Error updating Append Only:', error);
      toast.error('Failed to update Append Only setting');
    } finally {
      setBusy(false);
    }
  };

  const handleLockAcrossAllProjects = async () => {
    setBusy(true);

    try {
      await tenantApi.pdfEditting.editLockAppendOnly(user.tenantId, {
        lock_append_only: !lockAcrossAllProjects,
      });
      setLockAcrossAllProjects(!lockAcrossAllProjects);
      toast.success(
        `Lock Across All Projects ${
          !lockAcrossAllProjects ? 'enabled' : 'disabled'
        } successfully!`,
      );
    } catch (error) {
      console.error('Error updating Lock Across All Projects:', error);
      toast.error('Failed to update Lock Across All Projects setting');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className='settings-tenant-main-container'>
      <div
        className='settings-main-tenant-text'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
        onClick={() => setCollapse(!collapse)}
      >
        <h3>PDF Editing</h3>
        <i
          className={collapse ? 'fa fa-chevron-down' : 'fa fa-chevron-up'}
          aria-hidden='true'
        />
      </div>
      <hr />
      <div
        className={
          collapse ? 'administration-hidden' : 'administration-visible'
        }
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h3 style={{ marginTop: '0', marginLeft: '8px' }}>
            Enable PDF Annotation Restriction
          </h3>
          <ToggleSmall
            isChecked={appendOnlyEnabled}
            disabled={busy}
            handleChange={handleAppendOnlyToggle}
          />
        </div>
        {appendOnlyEnabled && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h3 style={{ marginTop: '0', marginLeft: '8px' }}>
              Lock Across All Projects
            </h3>
            <ToggleSmall
              isChecked={lockAcrossAllProjects}
              disabled={busy}
              handleChange={handleLockAcrossAllProjects}
            />
          </div>
        )}
      </div>

      <br />
    </div>
  );
};

export default PDFEditting;
